/**
 * Client-side cookie utility.
 *
 * Uses the direct cookie API — Biome's noDocumentCookie rule is
 * disabled for this file via biome.json override since the Cookie
 * Store API lacks Firefox/Safari support.
 */

export function setCookie(name: string, value: string, maxAge: number): void {
  document.cookie = `${name}=${value};max-age=${String(maxAge)};path=/;samesite=lax`;
}

export function getCookie(name: string): string | undefined {
  const prefix = `${name}=`;
  const entry = document.cookie.split('; ').find((c) => c.startsWith(prefix));
  return entry?.slice(prefix.length);
}
